
import state from './moduleClientUserManagementState'
import mutations from './moduleClientUserManagementMutations'
import actions from './moduleClientUserManagementActions'
import getters from './moduleClientUserManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

